export default __webpack_public_path__ + "static/media/ninjavan-logo.aeba2ff5.png";